'use strict';

module Patersons {

    export class NewsService extends BaseService {
        getNews(): ng.IPromise<any> {
            return this.get("/dataService/api/News");
        };
    }
}